var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.router)?_c('ul',{staticClass:"menu-wrapper",class:{'show-sep':_vm.showSeparator}},_vm._l((_vm.router.children),function(item,index){return _c('menu-item',{key:index,attrs:{"menuItem":item}},[_vm._t("default",function(){return [_c('menu-lst',{attrs:{"router":item}})]},{"slot":"sub"})],2)}),1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61cbfd30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/droplist/index.vue
// module id = null
// module chunks = 